import bootstrap from "bootstrap/dist/js/bootstrap.bundle";

export default defineNuxtPlugin((nuxtApp) => {
	// nuxtApp.vueApp.use(bootstrap);
  nuxtApp.provide('bootstrap', bootstrap);
});
